import { queryKeysFactory } from './query-key-factory';

export const caseListQueyKeys = queryKeysFactory('caseList');
export const teamsQueryKeys = queryKeysFactory('team');
export const usersQueryKeys = queryKeysFactory('users');
export const clientsQueryKeys = queryKeysFactory('clients');
